<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/unidades">Unidades</router-link>
          </li>
          <li class="breadcrumb-item active">Criar nova Unidade</li>
        </ol>


        <div class="box_general padding_bottom mb-5">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Unidade
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome da Unidade</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="unidade.nome_unidade"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Vínculo</label>
                <v-select
                  label="nome_empresa"
                  class="form-select"
                  v-model="unidade.empresas_id"
                  :reduce="empresas => empresas.id"
                  :options="empresas"
                  :searchable="true"
                >
                </v-select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  class="form-control"
                  v-model="unidade.CEP"
                  type="text"
                  v-mask="['#####-###']"
                />
              </div>
            </div>  
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Logradouro</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="unidade.logradouro"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="unidade.bairro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  v-model="unidade.numero"
                  type="numeric"
                />
              </div>
            </div>
          </div>

          <div class="col-md-12 mb-4">
            <p>
              <button href="#0" class="btn_1 medium pull-right" @click="criarUnidade()">Salvar</button>
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      unidade: {
        nome_unidade: '',
        CEP: '',
        logradouro: '',
        bairro: '',
        numero: '',
        empresas_id: '',
      },
      empresas: []
    };
  },

  mounted() {
    let self = this;

    axios.get('empresas')
      .then((res) => {
        self.empresas = res.data;
        self.isLoading = false;
      }, err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      })
  },

  methods: {
    criarUnidade() {
      let self = this;
        
      if(self.unidade.nome_unidade && self.unidade.CEP && self.unidade.logradouro &&
      self.unidade.bairro && self.unidade.numero && self.unidade.empresas_id !== '') {
        self.isLoading = true;

        let objRequest = new FormData();

        objRequest.append('nome_unidade', self.unidade.nome_unidade);
        objRequest.append('CEP', self.unidade.CEP);
        objRequest.append('logradouro', self.unidade.logradouro);
        objRequest.append('bairro', self.unidade.bairro);
        objRequest.append('numero', self.unidade.numero);
        objRequest.append('empresas_id', self.unidade.empresas_id);
        
        ajax("post", "unidades", objRequest)
          .then(res => {
            self.isLoading = false;
            let id_unidade = res.id;
            alerta(
              "success",
              "Sucesso",
              "Unidade cadastrada!"
            );

            self.$router.replace(this.$route.query.redirect || `/adm_master/unidades/${id_unidade}`);
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      } else {
        alerta('warning', 'Atenção', 'Preencha todos os campos');
      }
    },
  }
};
</script>
